import {useMutation, useQueryClient} from "react-query";
import {request, requestAxios} from "../../Axios/axios-util";
import {IRequestParamsPost} from "../../Interfaces/IRequestParams";

const postQuery = async ({service, method, payload, headers}: any) => {
  let urlStub: string = service;
  return request({
    url: urlStub,
    method: method,
    data: payload,
    headers: headers
  }).then((res) => res);
};

const postQueryAxios = ({service, method, payload, headers}: any) => {
  let urlStub: string = service;
  return requestAxios({
    url: urlStub,
    method: method,
    data: payload,
    headers: headers
  });
};

export const usePostApiRequestNew = () => {
  const {mutate, isLoading, isError, data, isSuccess} = useMutation(postQuery)
  return {mutate, isLoading, isError, data, isSuccess};
}

export const usePostApiRequest = (parmas: IRequestParamsPost) => {
  const queryClient = useQueryClient();
  return useMutation(postQuery, {
    onSuccess: parmas.onSuccess,
    onError: parmas.onError,
    onSettled: () => {
      queryClient.invalidateQueries('create');
    }
  });
}

export const usePostApiRequestAxios = (parmas: IRequestParamsPost) => {
  const queryClient = useQueryClient();
  return useMutation(postQueryAxios, {
    onSuccess: parmas.onSuccess,
    onError: parmas.onError,
    onSettled: () => {
      queryClient.invalidateQueries('create');
    }
  });
}